import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import profileApi from "api/profile";
import { actions } from "store/actions";
import useNotify from "hooks/useNotify";
import { scrollIntoView } from "utils/helper";
import { certificationType } from "utils/constantValues";

function useProfileCertifications({ profileCompletionRef = {} }) {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});

  const currentCertificationIds =
    userDetails?.userFiles
      ?.filter((file) => file.type === certificationType)
      ?.map((file) => file.id) ?? [];

  const { notifyError, notifySuccess } = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditCertificationFiles, setIsEditCertificationFiles] =
    useState(false);

  profileCompletionRef.certification = {
    openEdit: setIsEditCertificationFiles,
    certifications: currentCertificationIds,
  };

  const onEditCertificationsFiles = async (values) => {
    try {
      setIsLoading(true);

      const vendorId = userDetails?.vendorId;
      const agencyId = userDetails?.agencyId;
      const { newCreated, deleted } = values;

      const deletedIds = deleted?.map((el) => el.fileId) ?? [];

      const payload = {
        newCreated:
          newCreated
            ?.filter(
              (el) =>
                !deletedIds.includes(el.fileId) &&
                !currentCertificationIds.includes(el.fileId)
            )
            ?.map((el) => el.fileId) ?? [],
        deleted: deletedIds,
        type: certificationType,
      };

      if (vendorId) {
        await profileApi.updateVendorCertificationApi(vendorId, payload);
      } else {
        await profileApi.updateAgencyFiles(agencyId, {
          ...payload,
          type: certificationType,
        });
      }

      const userData = await profileApi.getUserProfileByIdApi(userDetails?.id);
      dispatch(actions.setUserDetails(userData));
      setIsEditCertificationFiles(false);
      notifySuccess("Has been updated succe sfully");

      scrollIntoView("certificationScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    isEditCertificationFiles,
    setIsEditCertificationFiles,
    onEditCertificationsFiles,
    isCertificationLoading: isLoading,
  };
}

export default useProfileCertifications;
